import React, { createElement, useState } from 'react';
import moduleCss from './index.module.scss'

export interface TabsProps {
    nodeId?: string;
    style?: object
    children?: any;
    tabList: {
        title: string
    }[];

    tabWidth?: number
    tabHeight?: number
    tabGap?: number
    contentGap?: number

    tabStyle?:object // 普通态

    tabActiveStyle?: object // 激活态
}

const Tabs: React.FC<TabsProps> = (props) => {
    const { nodeId, style, tabList, children, tabWidth, tabHeight, tabGap, contentGap, tabStyle, tabActiveStyle } = props;
    const [ current, setCurrent ] = useState(0)

    return (
        <div id={nodeId} className={moduleCss.tabs} style={style}>
            <div className={moduleCss.tabsTitleList}>
                {
                    tabList.map((tab, index) => {
                        return (
                            <div
                                className={moduleCss.tabTitle}
                                key={index}
                                onClick={() => setCurrent(index)}
                                style={{ width: `${tabWidth}px`, height: `${tabHeight}px`, marginRight: index === tabList.length - 1 ? '' : `${tabGap}px`, ...tabStyle, ...(current === index ? tabActiveStyle : {}) }}
                            >
                                {tab?.title}
                            </div>
                        )
                    })
                }
            </div>
            <div style={{ marginTop: `${contentGap}px` }}>
                {
                    children.map((item, index) => {
                        return (
                            <div style={{ display: index === current ? 'block' : 'none' }}>
                                {item}
                            </div>
                        )
                    })
                }
            </div>
        </div>
    );
};

export default Tabs;
